import { useCallback } from "react";
import { useDateFormatter } from "../../hooks/date";

export const useFormatDateAsTimeString = () => {
    const intlFormat = useDateFormatter();

    return useCallback(
        (date: Date | null, isDuration: boolean) => {
            if (!date) {
                return "";
            }
            if (isDuration) {
                const hours = date.getHours();
                const minutes = date.getMinutes();
                return `${hours.toString().padStart(2, "0")}:${minutes
                    .toString()
                    .padStart(2, "0")}`;
            }
            return intlFormat(date, {
                hour: "numeric",
                minute: "numeric",
            });
        },
        [intlFormat],
    );
};
